<dl-section-header [titleDcr]="titleDcrKey" [subTitleDcr]="subTitleDcrKey" [showSectionSeparator]="true" [poweredByDcr]="''" [asOfDate]="asOfDate"></dl-section-header>
<ng-container *ngIf="data.success && isTableDataTabValid; else invalidTab">
	<data-table [tableData]="tableData" [sortable]="true" [renderPSView]="true"></data-table>
</ng-container>

<ng-template #invalidTab>
	<div dcrHTMLKey="ESG_HOLDINGS_TABLE_NO_DATA">ESG characteristics are not available for portfolio holdings.</div>
</ng-template>
